<!--
  Solicitudes de crédito — listado. Consola de CrediTotal (todos los comercios).

  Rediseño 2026-09-20 — el contrato del rediseño («demasiada caja, demasiado contenido,
  la vista se pierde») sobre el de los documentos 63, 64 y 66 de
  `~/Documents/multicomercio/competencia/`. Lo que se midió antes de tocar nada, y lo
  que se hizo con cada cosa:

    · LA TABLA ARRANCABA A ~1.000 px. La tarjeta «Reparto del período» medía ~800 px
      ella sola: tres grupos de barras por estado más el bloque de etapas del cobro.
      Quien entra a buscar una solicitud veía un gráfico y tenía que rodar. Ahora el
      reparto es una FRANJA de ~100 px —una barra apilada por los tres grupos, y los
      números que no están en ningún otro lado— y la primera fila de la tabla queda
      arriba del corte, sin rodar.

    · EL MISMO FILTRO ESTABA DOS VECES. Los cinco cortes y las barras del reparto
      escribían el MISMO `status`, y «Trabadas» y la barra `COBRO_INCOMPLETO` la misma
      `etapa`. Quedaron los cortes y el reparto dejó de filtrar (el porqué, en el
      comentario de `cortes` del .ts). Por eso el renglón «cada barra aplica ese
      filtro» ya no está: no hay barra que tocar.

    · FUERA LAS DOS CAJAS. El reparto y el listado eran dos `.kb-card` para agrupar
      cosas que sólo se leen. Son secciones planas (`.kb-seccion`), que es el molde.

    · TRES DATOS QUE EL SERVIDOR YA MANDA Y NO SE VEÍAN — y por los que además se
      puede filtrar: el cajero declarado, el número del crédito y la factura del
      comercio (`listado-solicitudes.js:aItem`).

  Todo el estilo sale de las clases `.kb-*` de `src/styles.css` y de utilidades de
  Tailwind. Sin Bootstrap, sin colores crudos, sin modal: el detalle es una página
  aparte (`/console/solicitudes-credito/:code`).
-->
<div class="kb-page kb-gateway">
  <div class="space-y-8">

    <!-- ══ Encabezado + comercio/período ════════════════════════════════════ -->
    <div class="kb-page-header">
      <div>
        <h1 class="kb-page-title">Solicitudes de crédito</h1>
        <p class="kb-page-meta">Las que nacen en la caja del canal POS, y en qué paso quedaron.</p>
      </div>

      <!-- ⚠️ Este select se queda: el selector de comercio de la barra superior manda
           `?merchant=CODE` por el interceptor y el back de solicitudes sólo lee
           `merchant_code`, así que el de arriba no filtra nada acá. Que los dos se
           entiendan es trabajo del back, no de esta pantalla. -->
      <div class="flex flex-wrap items-end gap-3">
        <div>
          <label class="kb-label" for="fComercio">Comercio</label>
          <div class="kb-select-envoltorio w-full sm:w-48">
            <select id="fComercio" class="kb-select" [(ngModel)]="filtros.merchant_code" (ngModelChange)="onFiltroInmediato()">
              <option value="">Todos los comercios</option>
              <option *ngFor="let c of comercios" [value]="c.code">{{ c.name }}</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
        </div>
        <div class="flex items-end gap-2">
          <div>
            <label class="kb-label" for="fDesde">Desde</label>
            <input id="fDesde" type="date" class="kb-input w-[9.5rem]" [(ngModel)]="filtros.desde" (ngModelChange)="onFiltroInmediato()">
          </div>
          <div>
            <label class="kb-label" for="fHasta">Hasta</label>
            <input id="fHasta" type="date" class="kb-input w-[9.5rem]" [(ngModel)]="filtros.hasta" (ngModelChange)="onFiltroInmediato()">
          </div>
        </div>
      </div>
    </div>

    <!-- ══ Cargando / error ═════════════════════════════════════════════════ -->
    <div class="kb-skeleton h-16 w-full" *ngIf="cargando"></div>

    <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && error">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p class="kb-aviso-titulo">No se pudieron traer las solicitudes</p>
        <p>{{ error }}</p>
        <!-- «Reintentar» solo es un verbo sin objeto: el botón dice QUÉ vuelve a pedir,
             con el mismo verbo que ya usa la ficha de Organización. -->
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" *ngIf="errorReintentable" (click)="cargar()">
          <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar el listado
        </button>
        <!-- Un «no se resuelve reintentando» sin salida deja al operador parado: el
             servidor dijo `retryable:false`, casi siempre porque el usuario no tiene
             permiso sobre ese comercio. Se le dice qué probar y a quién avisar. -->
        <p class="kb-hint mt-2" *ngIf="!errorReintentable">
          Esto no se resuelve reintentando. Si estás filtrando por un comercio, quita ese filtro y
          prueba de nuevo; si sigue igual, pásale a soporte el mensaje de arriba y la hora.
        </p>
      </div>
    </div>

    <!-- ══ El reparto del período — una franja, sin tarjeta y sin botones ════
         Lo que queda acá son los números que NO están en ningún otro lado: la
         proporción, el desglose de las que no llegaron y el resultado del cobro.
         Los conteos por corte viven en los cortes, doce centímetros más abajo. -->
    <section class="kb-tarjeta" *ngIf="!cargando && !error && total > 0">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Reparto del período</h2>
        <span class="kb-tarjeta-accion shrink-0 text-sm text-muted-foreground">
          Vendido <span class="ml-1 font-semibold tabular-nums text-foreground">{{ formatoMonto(vendidoUsd) }}</span>
          <span class="ml-1 tabular-nums">de {{ formatoMonto(montoUsd) }} pedido</span>
        </span>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <div class="flex h-2.5 w-full overflow-hidden rounded-sm bg-muted" role="img" [attr.aria-label]="ariaFranja">
        <span class="block h-full" *ngFor="let g of gruposEstado"
              [style.width.%]="g.pct" [style.backgroundColor]="g.color"></span>
      </div>

      <!-- El rótulo escrito va SIEMPRE al lado del color: el color nunca es lo único
           que distingue un grupo (validador de daltonismo del skill `dataviz`). -->
      <div class="flex flex-wrap items-center gap-x-5 gap-y-1.5">
        <span class="flex items-center gap-2 text-xs text-foreground" *ngFor="let g of gruposEstado">
          <span class="h-2.5 w-2.5 shrink-0 rounded-sm" [style.backgroundColor]="g.color" aria-hidden="true"></span>
          {{ g.titulo }}
          <span class="tabular-nums text-muted-foreground">{{ g.subtotal }} · {{ g.pct | number:'1.0-1':'es-VE' }} %</span>
        </span>
      </div>

      <p class="kb-hint" *ngIf="desgloseNoLlegaron">No llegaron: {{ desgloseNoLlegaron }}</p>
      <p class="kb-hint" *ngIf="resultadoDelCobro">Resultado del cobro: {{ resultadoDelCobro }}</p>
      <p class="kb-hint" *ngIf="coberturaEstadoTexto">{{ coberturaEstadoTexto }}</p>
      </div>
    </section>

    <!-- ══ El listado: búsqueda + cortes + tabla + paginación ════════════════ -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Listado</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">

      <!-- Buscar y cortar, en el mismo renglón: son las dos maneras de llegar a una
           fila, y separadas en dos franjas costaban 60 px de alto. -->
      <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div class="min-w-0 flex-1">
          <div class="kb-buscador max-w-md">
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <input type="text" class="kb-input kb-input-icono" autocomplete="off"
                   aria-label="Buscar por cédula del cliente, código de solicitud, número de crédito o factura"
                   placeholder="Cédula, SOL-…, CREDIT-… o número de factura"
                   [(ngModel)]="busquedaTexto" (ngModelChange)="onBusquedaCambio()" (keyup.enter)="onEnterBusqueda()">
          </div>

          <div class="mt-1.5" *ngIf="esCodigoDeSolicitud">
            <button type="button" class="text-xs font-medium text-primary hover:underline" (click)="abrirPorCodigo()">
              <i class="fas fa-arrow-right" aria-hidden="true"></i> Abrir la solicitud {{ codigoSugerido }}
            </button>
          </div>

          <div class="mt-1.5 flex flex-wrap gap-x-4 gap-y-1" *ngIf="busquedaEsAmbigua">
            <button type="button" class="text-xs text-primary hover:underline" (click)="resolverAmbiguo('cajero')">
              ¿Buscabas la cédula del cajero?
            </button>
            <button type="button" class="text-xs text-primary hover:underline" (click)="resolverAmbiguo('credito')">
              ¿el número de crédito?
            </button>
          </div>
        </div>

        <!-- Los cinco cortes — leídos en fila cuentan el proceso. Son el ÚNICO
             control que escribe `status` y `etapa`. -->
        <div class="kb-tabs shrink-0" role="tablist" aria-label="Cortes por estado del proceso">
          <button type="button" class="kb-tab" *ngFor="let c of cortes"
                  [ngClass]="{'kb-tab-activo': corteActivo === c.clave,
                              'kb-anillo-alerta': c.clave === 'trabadas' && c.valor > 0 && corteActivo !== 'trabadas'}"
                  [attr.aria-pressed]="corteActivo === c.clave"
                  (click)="aplicarCorte(c.clave)">
            {{ c.texto }}
            <span class="ml-1 tabular-nums"
                  [ngClass]="c.clave === 'trabadas' && c.valor > 0 ? 'font-semibold text-amber-700 dark:text-amber-400' : 'opacity-60'">
              {{ c.valor }}
            </span>
          </button>
        </div>
      </div>

      <!-- Todo lo filtrado queda como pastilla que se puede quitar. -->
      <div class="flex flex-wrap items-center gap-2" *ngIf="pastillas.length || hayFiltros">
        <button type="button" class="kb-chip kb-chip-activo" *ngFor="let p of pastillas" (click)="p.quitar()">
          {{ p.etiqueta }}<i class="fas fa-times ml-1.5" aria-hidden="true"></i>
        </button>
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="hayFiltros" (click)="limpiarFiltros()">
          <i class="fas fa-times" aria-hidden="true"></i>Limpiar filtros
        </button>
      </div>

      <!-- ── Tabla ────────────────────────────────────────────────────────── -->
      <div class="kb-tabla-plana">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Solicitud</th>
              <th class="kb-th">Cliente</th>
              <th class="kb-th">Punto de venta</th>
              <th class="kb-th">Estado</th>
              <th class="kb-th kb-th-num">Monto</th>
            </tr>
          </thead>

          <tbody>
            <!-- Cargando: el esqueleto conserva la forma de la tabla -->
            <tr class="kb-tr" *ngIf="cargando">
              <td class="kb-td" colspan="5">
                <div class="space-y-3 py-2">
                  <div class="kb-skeleton h-4 w-full" *ngFor="let s of [1,2,3,4,5]"></div>
                </div>
              </td>
            </tr>

            <!-- Vacío: dos frases distintas para dos hechos distintos -->
            <tr *ngIf="!cargando && !error && !items.length">
              <td colspan="5">
                <div class="kb-empty">
                  <span class="kb-empty-icono">
                    <i class="fas" [ngClass]="hayFiltros ? 'fa-filter' : 'fa-inbox'" aria-hidden="true"></i>
                  </span>
                  <p class="kb-empty-titulo">
                    {{ hayFiltros ? 'Ninguna solicitud coincide con este filtro' : 'Todavía no hay solicitudes' }}
                  </p>
                  <p class="kb-empty-texto">
                    {{ hayFiltros
                       ? 'Prueba con otro rango de fechas, con otro comercio, o quita alguno de los filtros.'
                       : 'Aquí van a aparecer las que nazcan en la caja de algún comercio del canal POS.' }}
                  </p>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="hayFiltros"
                          (click)="limpiarFiltros()">Limpiar filtros</button>
                </div>
              </td>
            </tr>

            <!-- Las filas -->
            <tr class="kb-tr kb-tr-clic last:border-b-0" *ngFor="let it of items"
                [ngClass]="{'kb-tr-atenuada': it.status === 'ANULADA'}"
                (click)="abrirDetalle(it)">

              <!-- El número del crédito y la factura del comercio ya viajaban en cada
                   fila y no se veían — y son por los que busca el que atiende un
                   reclamo. `credito` sin `numero` es un crédito que existe y cuyo
                   número la solicitud no guardó: se dice, no se calla. -->
              <td class="kb-td">
                <span class="kb-td-titulo kb-td-mono">{{ it.code }}</span>
                <p class="kb-td-sub tabular-nums">{{ it.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
                <p class="kb-td-sub" *ngIf="it.llenado_posterior" title="La solicitud se creó después del crédito, en la caja del modelo anterior">Llenado posterior</p>
                <p class="kb-td-sub" *ngIf="it.credito || it.factura">
                  <span *ngIf="it.credito">{{ it.credito.numero || 'crédito sin número guardado' }}</span>
                  <span *ngIf="it.credito && it.factura"> · </span>
                  <span *ngIf="it.factura">factura {{ it.factura }}</span>
                </p>
              </td>

              <!-- 2026-09-25: el nombre del cliente arriba y la cédula debajo, como en el portal. -->
              <td class="kb-td">
                <span class="block" *ngIf="it.cliente?.nombre">{{ nombrePropio(it.cliente.nombre) }}</span>
                <span class="tabular-nums" [ngClass]="it.cliente?.nombre ? 'kb-td-sub block' : ''">{{ cedula(it.cliente?.cedula) }}</span>
              </td>

              <td class="kb-td">
                <span *ngIf="it.comercio?.name">{{ it.comercio.name }}</span>
                <span class="italic text-muted-foreground" *ngIf="!it.comercio?.name">—</span>
                <p class="kb-td-sub" *ngIf="it.tienda !== null || it.caja !== null || it.cajero_cedula">
                  <button type="button" class="hover:text-foreground hover:underline" *ngIf="it.tienda !== null"
                          title="Filtrar por esta tienda" (click)="filtrarPorTienda(it.tienda, $event)">
                    {{ tiendaSinComercio(it) }}
                  </button>
                  <span *ngIf="it.tienda !== null && it.caja !== null"> · </span>
                  <button type="button" class="hover:text-foreground hover:underline" *ngIf="it.caja !== null"
                          title="Filtrar por esta caja" (click)="filtrarPorCaja(it.caja, $event)">
                    caja {{ it.caja }}
                  </button>
                  <span *ngIf="(it.tienda !== null || it.caja !== null) && it.cajero_cedula"> · </span>
                  <button type="button" class="hover:text-foreground hover:underline" *ngIf="it.cajero_cedula"
                          title="Filtrar por este cajero. Es la cédula que el cajero declaró al cobrar, no una atribución probada"
                          (click)="filtrarPorCajero(it.cajero_cedula, $event)">
                    cajero {{ cedula(it.cajero_cedula) }}
                  </button>
                </p>
              </td>

              <td class="kb-td">
                <span class="kb-badge" [ngClass]="[estadoNegocio(it).clase, estadoNegocio(it).anillo ? 'kb-anillo-alerta' : '']">
                  {{ estadoNegocio(it).texto }}
                </span>
                <p class="kb-td-sub" *ngIf="estadoNegocio(it).renglon">{{ estadoNegocio(it).renglon }}</p>
              </td>

              <td class="kb-td kb-td-num">
                <span class="font-medium">{{ formatoMonto(it.monto_usd) }}</span>
                <p class="kb-td-sub tabular-nums" *ngIf="it.inicial_usd">inicial {{ formatoMonto(it.inicial_usd) }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ── Paginación (la resuelve el servidor) — la única vez que se dice el
           total (documento 66 §5). Sin el borde de arriba de `.kb-pager`: la tabla
           ya cierra con el suyo y dos líneas paralelas no separan nada. ──────── -->
      <div class="kb-pager border-t-0 px-0" *ngIf="!cargando && total > porPagina">
        <p class="kb-toolbar-conteo">Mostrando {{ desdeFila }}–{{ hastaFila }} de {{ total }}</p>
        <div class="flex items-center gap-2">
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                  [disabled]="paginaActual === 1" (click)="irAPagina(paginaActual - 1)">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>Anterior
          </button>
          <span class="text-sm tabular-nums text-muted-foreground">{{ paginaActual }} / {{ totalPaginas }}</span>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                  [disabled]="paginaActual === totalPaginas" (click)="irAPagina(paginaActual + 1)">
            Siguiente<i class="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      </div>
    </section>
  </div>
</div>
